import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHD_VERSIONS_REQUEST = 'GET_WHD_VERSIONS_REQUEST';
export const GET_WHD_VERSIONS_SUCCESS = 'GET_WHD_VERSIONS_SUCCESS';
export const GET_WHD_VERSIONS_FAILURE = 'GET_WHD_VERSIONS_FAILURE';

function request() {
  return {
    type: GET_WHD_VERSIONS_REQUEST
  };
}

function receive(versions) {
  return {
    type: GET_WHD_VERSIONS_SUCCESS,
    versions
  };
}

function reject() {
  return {
    type: GET_WHD_VERSIONS_FAILURE
  };
}

export function getStatementVersions(accountId, pageNumber) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .getStatementVersions(accountId, pageNumber)
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
